var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSharedAccount = function SvgSharedAccount(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#shared-account_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.88 16H3a3 3 0 0 0-3 3v6a1 1 0 1 0 2 0v-6a1 1 0 0 1 1-1h6.2c-.12.31-.2.65-.2 1v6a1 1 0 1 0 2 0v-6c0-.55.5-1 1.13-1h12.74c.63 0 1.13.45 1.13 1v6a1 1 0 1 0 2 0v-6c0-1.65-1.4-3-3.13-3ZM9.5 14c1.76 0 3.38-.75 4.5-2.03a6 6 0 1 0 0-7.94A6 6 0 1 0 9.5 14Zm5.4-7.74a4 4 0 1 1 7.2 3.5 4 4 0 0 1-7.2-3.5ZM9.5 4c1.4 0 2.66.7 3.39 1.87 0 .02 0 .04-.02.05-.1.3-.19.6-.25.91l-.03.2a6.02 6.02 0 0 0 0 1.94c0 .07.02.13.03.2.06.3.15.61.26.9v.06A4 4 0 1 1 9.5 4Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shared-account_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgSharedAccount;